import { Modal } from "antd";
import DOMPurify from "dompurify";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetResumeTemplates } from "../../ServiceHooks/resumeBuilderHooks";
import {
  getSafeHtml,
  resume_demo_datas,
} from "../../Utils/ResumeBuilder/Constant";
import ResumeForm from "./ResumeForm";

const ListResumeTemplates = () => {
  const { candidateId, userId } = useParams();
  const { data: resume_templates } = useGetResumeTemplates();

  const [openTemplate, setOpenTemplate] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  //   const resumes = [apiResponseData,apiResponseData1,apiResponseData2]

  const handleTemplateSelect = (data) => {
    setSelectedData(data);
    setOpenTemplate(true);
  };
  console.log("enter>>>", openTemplate);

  //   console.log(resume_templates, 'resume_templates',openTemplate);
  console.log(selectedData, "selectedData");
  return (
    <>
      <h2 className="text-[20px] w-full ml-20 mt-6">Select Template</h2>
      <div className="mt-5 ml-20 ">
        <div className="flex gap-8 justify-start flex-wrap w-full items-center pageContent scrollbar-hide ">
          {resume_templates?.results?.map((re, index) => (
            <div className="w-[100%] mid-s:w-[45%] 2xl:w-[31%] px-10 md:px-14 lg:px-14 mid-s:px-0 mb-24">
              <p className="mb-2">{re?.template_name}</p>
              <div
                onClick={() => handleTemplateSelect(re)}
                className="bg-[#fff] cursor-pointer w-full hover:shadow-2xl max-h-[90vh] h-[90vh] overflow-y-auto customScrollBar"
                dangerouslySetInnerHTML={{
                  __html: getSafeHtml(re?.resume_template, resume_demo_datas),
                }}
              />
            </div>
          ))}
        </div>
        {openTemplate && (
          <Modal
            className="offlineReportModal"
            width={1200}
            open={openTemplate}
            title={null}
            onCancel={() => setOpenTemplate(false)}
            footer={null}
            destroyOnClose
            bodyStyle={{
              paddingTop: "2rem",
            }}
          >
            <ResumeForm
              template={selectedData?.resume_template}
              title={selectedData?.template_name}
              fields={selectedData?.required_fields}
              userId={userId}
              candidate_id={candidateId}
              template_id={selectedData?.id}
              close={setOpenTemplate}
            />
          </Modal>
        )}
      </div>
    </>
  );
};

export default ListResumeTemplates;
